<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/nvav_logo.png')"
          class="my-3"
          contain
          height="100px"
        />
        <h1> Welcome to TZ-App</h1>
        <h3>Commissie Technische Zaken</h3>
      </v-col>
    </v-row>
  </v-container>

</template>

<style scoped>
 h1 {
   font-size: x-large;
   font-variant-caps: all-small-caps;
   color: #f04e23;
  }

 h3 {
   //color: #4682b4;
   font-variant-caps: all-small-caps;
 }
  .v-main {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
</style>

<script>

export default {
  name: "TZHeader",

  data: () => ({
  }),
};
</script>
